<kuv-alert></kuv-alert>
<kuv-loading></kuv-loading>

<div class="container-fluid p-5">
    <h3>Gestión de Tipos de Actualización</h3>
    <button class="btn btn-primary my-2" (click)="add()"><i class="fas fa-plus-circle me-2"></i>Registrar Tipo de
        Actualización</button>
    <br>
    <kuv-lazy-table url={{url}} [pageSize]="20" [reloadEmitter]="reloadEmitter" [headers]="sesion.headers"
        [urlExcel]="config.apiUrl + 'tipo-actualizacion/excel'" [headersBlob]="sesion.headersBlob" [filtros]="filtros"
        [columnas]="columnas" [acciones]="acciones" [useIndex]="true" [isRounded]="true"
        [hasShadow]="true"></kuv-lazy-table>
</div>